import React from 'react';
import StepperComponent from './StepperComponent';
import StepManager from './StepManager';

interface StepItem {
    label: string;
    component: JSX.Element;
}

interface StepNavigatorProps {
    step: number;
    steps: StepItem[];
}

const StepNavigator: React.FC<StepNavigatorProps> = ({ step, steps }) => {
    return (
        <>
            <StepperComponent activeStep={step} steps={steps.map((s) => s.label)} />
            <StepManager step={step} steps={steps.map((s) => ({ component: s.component }))} />
        </>
    );
};

export default StepNavigator;
